import React, { useState } from 'react';
import { ContractType } from '../../../../sp-types/clientOrderQuoteType';
import { ToolTipCircle } from '../../../../components/UI-Elements/ToolTipCircle';
import ButtonDesigned from '../../../../components/UI-Elements/Buttons/ButtonDesigned';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface CoSelectContractTypeProps {
  contractTypes?: ContractType[];
  nextButton: (_selectedFutureOrderType: string) => void;
}

export const FOSelectContractType: React.FC<CoSelectContractTypeProps> = ({
  contractTypes = contracts,
  nextButton,
}) => {
  const [selectedContract, setSelectedContract] = useState('');

  return (
    <div className="flex flex-col h-full   ">
      <div className="flex flex-1 sm:flex-wrap md:flex-nowrap  justify-center  xl:space-x-[5rem] lg:space-x-[5rem] md:space-x-[2rem] sm:space-x-[1rem]">
        {contractTypes?.map((contract, index) => (
          <div
            key={index}
            className={`flex flex-col lg:w-[14.5rem] xl:w-[14.5rem] md:w-[14.5rem]  pt-[0.75rem] pe-[0.65rem] ps-[1rem] min-h-[11rem] my-auto rounded shadow-md hover:shadow-xl space-y-4 ${
              selectedContract === contract.name ? 'border-1 border-red-200 shadow-xl' : 'border border-gray-700'
            } ${contract.isDisabled && 'opacity-60 grayscale pointer-events-none'}`}
            onClick={() => {
              setSelectedContract(contract.name);
              nextButton(contract.name);
            }}
          >
            <div className={`flex justify-between  `}>
              <p className="text-xl text-red">{contract.name}</p>
              <div className="flex flex-col justify-start">
                <ToolTipCircle text="Lock-in description" lgSize="lg" xlgSize="xl" />
              </div>
            </div>
            <p className="text-sm text-secondary_text font-inter">{contract.description}</p>
          </div>
        ))}
      </div>
      {/* <div>
        <ButtonDesigned
          style="outline"
          onButtonClick={() => {
            nextButton(selectedContract);
          }}
        >
          Next
          <ChevronRightIcon />
        </ButtonDesigned>
      </div> */}
    </div>
  );
};

const contracts: ContractType[] = [
  {
    name: 'Fixed',
    description: 'Fixed price order for a specific future delivery date(s).',
    toolTip: 'Fixed price order for a specific future delivery date(s).',
  },
  {
    name: 'Indexed',
    description: 'Indexed future delivery contract',
    toolTip: 'Indexed future delivery contract',
  },
  {
    name: 'Framework Agreement',
    description: 'Fixed or indexed framework agreement for specific product with estimated future deliveries',
    toolTip: 'Fixed or indexed framework agreement for specific product with estimated future deliveries',
    isDisabled: true,
  },
];
